import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Skeleton from '@mui/material/Skeleton';
import { USER_LOADED_STATUS, useSingleUser } from 'features/users';
import { url as loadGravatarUrl } from 'gravatar';

export const UserAvatar = ({
  userId,
  variant = 'circular',
  sx,
  onClick = null,
}) => {
  const { user, loading } = useSingleUser(
    userId,
    false,
    USER_LOADED_STATUS.BASIC
  );
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    if (!user || loading) return;

    if (user.profileImage) {
      setImageSrc(user.profileImage);
      return;
    }

    const gravatarUrl = loadGravatarUrl(user.email, {
      protocol: 'https',
      rating: 'g',
      // Use the Pomp URL as the default
      d: 'https://app.pompbeauty.com/assets/32.png',
    });

    /**
     * Please forgive me for this hack.
     * It's impossible to tell the broswer to not throw 404 errors straight into the console or add prevention
     * into the HTML. The MUI element, Avatar, won't display children if the image is found. So using gravatar
     * blank also doesn't work... Sooo... This creates an in-memory image and then sets the image to the gravatar
     * url using the Pomp 32x32 logo as the default. Then when the image loads, it will check if the image is at
     * least the mandated 80 pixels, thus knowing it's a gravatar image without throwing a million 404 errors.
     */
    const image = new Image();
    image.src = gravatarUrl;
    image.onload = () => {
      // Default image, don't update
      if (image.width < 80) return;
      setImageSrc(gravatarUrl);
    };
  }, [user]);

  if (!userId || !user || loading) {
    return <Skeleton variant={variant} width={40} height={40} />;
  }

  const initials = `${user?.firstName?.[0]}${user?.lastName?.[0]}`;

  return (
    <Avatar sx={sx} onClick={onClick} variant={variant} src={imageSrc}>
      {initials.toLocaleUpperCase()}
    </Avatar>
  );
};

UserAvatar.propTypes = {
  userId: PropTypes.string,
  sx: PropTypes.object,
  onClick: PropTypes.func,
  variant: PropTypes.string,
};
